import { Grid, Paper } from '@material-ui/core';
import { connect } from 'react-redux';
import React, { useEffect } from 'react';
import CustomButton from '../../layout/customButton/CustomButton';
import styles from '../Deals.module.scss';
import PurchasesTable from './PurchasesTable';
import { getPurchasers } from '../../../redux/purchasers/actions';

const PurchasesSection = ({ search, purchasers, checked }) => {
	return (
		<Grid item xl={9} lg={9} xs={12}>
			<Paper className={styles.leads_table}>
				<PurchasesTable search={search} checked={checked} />
			</Paper>
		</Grid>
	);
};

const mapStateToProps = (state) => ({
	user: state.signIn,
	purchasers: state.purchasers.purchaserList,
});

export default connect(mapStateToProps)(PurchasesSection);
